export const FLOW_TYPE_AMAN_STANDARD = "FLOW_TYPE_AMAN_STANDARD";

export const STEP_NAME_START = "start";
export const STEP_NAME_QUESTIONNAIRE = "questionnaire";
export const STEP_NAME_PLAN = "plan";
export const STEP_NAME_DETAILS = "details";
export const STEP_NAME_PAY = "pay";

const aman_start_step = {
    name: STEP_NAME_START,
    substeps: [
        'basic_info',
        'documents_ready',
    ]
};

export const new_aman_flow = {
    [FLOW_TYPE_AMAN_STANDARD]: [
        aman_start_step,
        {
            name: STEP_NAME_QUESTIONNAIRE,
            substeps: [
                'health_questions',
            ]
        },
        {
            name: STEP_NAME_PLAN,
            substeps: [
                'choose_plan',
            ]
        },
        {
            name: STEP_NAME_DETAILS,
            substeps: [
                'domestic_helper_details',
            ]
        },
        {
            name: STEP_NAME_PAY,
            substeps: [
                'review_and_confirm',
                'payment_method',
                'payment_congratulations'
            ]
        },
    ],
};
